import { ApplicationConfig, LOCALE_ID } from "@angular/core";
import { APP_ROUTES } from "@app/app.routes";
import { provideRouter, withInMemoryScrolling, withComponentInputBinding } from "@angular/router";
import { AuthInterceptor } from "@utils/auth.interceptor";
import { ConfirmationService, MessageService } from "primeng/api";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    ),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([AuthInterceptor])
    ),
    {
      provide: LOCALE_ID,
      useValue: 'es-CO',
    },
    MessageService,
    ConfirmationService,
  ],
};
